import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Spin } from "antd";
import moment from "moment";

import {
  setRecordDates,
  setSearchText,
} from "../../../../redux/store/common/commonDuck";

const AnswerDashboard = ({ inquiryStatus }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const setDates = (value) => dispatch(setRecordDates(value));
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);

  return (
    <Row className="order-component-box main-component-box">
      {isLoading && <Spin />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">
          미답변문의
          <span
            className={`gray-font`}
            style={{
              marginLeft: "8px",
            }}
          >
            최근 30일 기준
          </span>
        </h2>
      </div>
      <div
        className={`order-component-info`}
        style={{
          gap: "1rem",
        }}
      >
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() => {
            setIsSearchText("unanswer");
            if (inquiryStatus.productInquiryList?.length > 0) {
              setDates({
                startDate: moment(
                  inquiryStatus.productInquiryList[
                    inquiryStatus.productInquiryList?.length - 1
                  ].created_at,
                ).startOf("day"),
                endDate: moment(
                  inquiryStatus.productInquiryList[0].created_at,
                ).endOf("day"),
              });
            } else {
              setDates({
                startDate: moment().subtract(7, "days").startOf("day"),
                endDate: moment().endOf("day"),
              });
            }
            history.push(`/inquiries/product`);
          }}
        >
          <span>상품문의</span>
          <p>
            <b>{inquiryStatus.productInquiryCnt}</b>
          </p>
        </Row>
        {user && user.role && user.role === "super_admin" && (
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => {
              history.push(`/inquiries/view`);
            }}
          >
            <span>추천문의</span>
            <p>
              <b>{inquiryStatus.pharmacyInquiryCnt}</b>
            </p>
          </Row>
        )}
        {user && user.role && user.role === "super_admin" && (
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => {
              setIsSearchText("unanswer");
              if (inquiryStatus.recommendInquiryList?.length > 0) {
                setDates({
                  startDate: moment(
                    inquiryStatus.recommendInquiryList[
                      inquiryStatus.recommendInquiryList?.length - 1
                    ].created_at,
                  ).startOf("day"),
                  endDate: moment(
                    inquiryStatus.recommendInquiryList[0].created_at,
                  ).endOf("day"),
                });
              } else {
                setDates({
                  startDate: moment().subtract(7, "days").startOf("day"),
                  endDate: moment().endOf("day"),
                });
              }
              history.push(`/inquiries/board`);
            }}
          >
            <span>상담게시판</span>
            <p>
              <b>{inquiryStatus.recommendInquiryCnt}</b>
            </p>
          </Row>
        )}
        {user && user.role && user.role === "super_admin" && (
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => {
              history.push(`/inquiries/service`);
            }}
          >
            <span>서비스문의</span>
            <p>
              <b>{inquiryStatus.csCnt}</b>
            </p>
          </Row>
        )}
      </div>
    </Row>
  );
};
export default AnswerDashboard;
